import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchConsumableApi, deleteConsumableApi, toggleConsumablePublishedStateApi } from './consumableSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional for styling
import Datatable from '~/components/Datatable';

export const customStyles = {
    table: {
        style: {
            border: '1px solid #F5F7FA',
        },
    },
    headCells: {
        style: {
            fontWeight: 'bold',
            padding: '15px',
        },
    },
};

function Consumable() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.itemSaga.consumable);

    const columns = [
        {
            name: '#',
            selector: (row) => row.id,
        },
        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
            center: true,
            grow: 2,
        },
        {
            name: 'Description',
            sortable: true,
            cell: (row) => {
                return (
                    <Tippy content={row.description}>
                        <div className="line-clamp line-clamp--2">{row.description}</div>
                    </Tippy>
                );
            },
            grow: 3,
        },
        {
            name: 'Rarity',
            selector: (row) => row.rarity,
            format: (row) => row.rarity.toUpperCase(),
        },
        {
            name: 'Edit/Remove',
            cell: (row) => (
                <EditDeleteBtn
                    row={row}
                    thunkFunc={deleteConsumableApi}
                />
            ),
        },
        {
            name: 'Published',
            cell: (row) => (
                <Form.Check
                    type="switch"
                    id={'published-' + row.id}
                    onChange={() => {
                        dispatch(toggleConsumablePublishedStateApi(row.id));
                    }}
                    checked={row.isReady}
                />
            ),
        },
    ];

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchConsumableApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-8 offset-sm-2">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default Consumable;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
